import {arrive} from "../../../../../webui/js/dom/flow.js";
import {loadStripe} from "./pure.js";
import {RedactorX} from "../vendor/redactorx_1_3_9/redactorx.js";
import {Glider} from "./glider.js";
import {new_scroll} from "./scroll.js";
import {ticker as new_ticker} from "./ticker.js";
import {b64_url_encode, empty, is_string, not_empty, parse_url, strcmp} from "../../../../../webui/js/support/util.js";
import {Scope} from "../../../../../webui/js/support/watch.js";
import {intercept_forms, submit_form_data, request_queue, xhr_response_text} from '../../../../../webui/js/dom/form.js';
import {
	descendants,
	is_child_of,
	is_html_anchor,
	is_html_button,
	matches_selector,
	parent_by_tag_name,
	parent_matches,
} from '../../../../../webui/js/dom/element.js';
import {install_modal} from "../../../../../webui/js/ui/modal.js"
import {emplace_token_list} from "../../../../../webui/js/dom/token_list.js";
import Sortable from "../../../../../sortable_js/src/Sortable.js";
import {emplace_privacy} from "../../../../../one/src/js/privacy.js"
import {merge_xhr_result} from "./lib.js";

let last_clicked_element

emplace_privacy()

/*function decode_data (data)
 {
 const raw_data = data;







 let protected_header =  cbor_decode(payload_data[0]);
 let unprotected_header = cbor_decode(payload_data[1]);

 let plaintext =  payload_data[2];
 let cose_signature =  payload_data[3];
 let cose_signature_hex = Array.from(cose_signature).map(i2hex).join('');

 let decoded_data = cbor_decode(typed_array_to_buffer_sliced(plaintext));

 let sig_structure = Array.from(cose_signature).map(i2hex).join('')

 return {
 protected_header,
 unprotected_header,
 decoded_data
 raw_data,

 cose_signature,
 cose_signature_hex,
 sig_structure,
 }
 }*/

function scan_qr (data)
{
	if (RegExp("^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$", "i").
	test(data))
	{
		// redirect to url
		window.location.assign(data);

		return true;
	}
	else {

		data = b64_url_encode(data);
		window.location.href = "/check#" + data;

		//alert(dcc.sign_algorithm());

		//data = decode_data(data);

		//console.log(JSON.stringify(data));
		//alert(JSON.stringify(data));

		/*let headers1, headers2, cbor_data, signature;
		 [headers1, headers2, cbor_data, signature] = data;
		 cbor_data = cbor_decode(cbor_data.buffer);

		 alert(cbor_data);*/

		return true;
	}

	return false;
}

window.document.addEventListener('click', (e) => {

	if (is_html_button(e.target)) {
		last_clicked_element = e.target
	}
	else {
		const button = parent_by_tag_name(e.target, 'button');
		if (button) {
			last_clicked_element = button;
		}
	}

	log('capturing last clicked element ' + last_clicked_element)

}, {passive: true, capture: true});

function on_merge_result (req_url, resp_url)
{
	if (resp_url) {
		const origin_url = parse_url(window.location.href)
		resp_url = parse_url(resp_url)
		req_url = parse_url(req_url)

		let hash = [resp_url.hash, req_url.hash].find(not_empty)
		if (window.location.hash && !hash) {
			hash = window.location.hash
		}

		let target_id = hash ? hash.substr(1) : null
		if (0 === strcmp(origin_url.pathname, resp_url.pathname) && !hash) {
			window.location.hash = hash;
		}
		else {
			const url = resp_url.toString()
			const page_info = {
				url, title: ''
			}

			log("pushstate, targeting " + is_targeting + ",document location: " + document.location + ", page info: " + JSON.stringify(page_info));

			history.pushState(page_info, page_info.title, page_info.url)

			scroll_to(target_id || document.body)
		}
	}
}

let is_targeting = false

function scroll_to (element_to_scroll_to)
{
	if (is_string(element_to_scroll_to)) {
		element_to_scroll_to = document.getElementById(element_to_scroll_to);
	}

	if (element_to_scroll_to instanceof HTMLElement) {
		element_to_scroll_to.scrollIntoView();
	}
}


function start_progress ()
{
	const progress_elem = document.getElementById('progress')
	if (progress_elem) {
		progress_elem.removeAttribute('hidden');
	}
}

function end_progress ()
{
	const progress_elem = document.getElementById('progress')
	if (progress_elem) {
		progress_elem.setAttribute('hidden', '');
	}
}

function log (msg)
{
	//console.log(msg);
}

function new_xml_http_request (method, url, async)
{

	const xhr = new XMLHttpRequest
	xhr.open(method, url, async)

	xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
	xhr.setRequestHeader("Accept", "text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8")

	xhr.addEventListener("load", () => {
		end_progress()
	})

	xhr.addEventListener("loadstart", () => {
		start_progress()
	})

	xhr.addEventListener("progress", event => {
		if (event.lengthComputable) {
			const complete = (event.loaded / event.total * 100 | 0)
			console.log(complete + '%')
		}
		else {
			console.log("on progress, not computable")
		}
	})

	return xhr
}

function init_infinite ()
{
	window.addEventListener('load', () => {
		requestAnimationFrame(() => {

			const el = document.querySelector("#infinity .gt-scroll")
			const scroller = document.querySelector("#infinity .gt-scroll > .gt-tiles")

			if (el && scroller) {
				const model_items = []
				document.querySelectorAll("#infinity .gt-scroll .gt-tile").forEach(function (n) {
					model_items.push(n.cloneNode(true));
				});

				const infinite = new_scroll({
					wrapper: el,
					scroller: '#infinity .gt-scroll > .gt-tiles',
					items: '.gt-tile',
					scrolly: false,
					scrollx: true,
					carousel: true,
				})

				let position = 0

				let speed_in_px_per_ms = 0.06


				let hovered = false
				scroller.addEventListener('mousemove', (e) => speed_in_px_per_ms = 0.03)
				scroller.addEventListener('mouseleave', (e) => speed_in_px_per_ms = 0.06)

				const ticker = new_ticker((time, delta) => {

					const scroller_width = (Math.round(infinite.scroller_size() / 3))

					const distance_to_move = speed_in_px_per_ms * delta

					position -= distance_to_move

					if (position < -scroller_width) {
						// Überprüfen, ob der Inhalt vollständig verschoben ist, und ihn gegebenenfalls zurücksetzen

						console.log("position is " + position)

						position = 0

						console.log("reset to 0, " + scroller.offsetWidth)
					}

					//const matrix = `matrix(1,0,0,1,${position},0`
					//scroller.style.transform = matrix

					infinite.scroll_to(position, 0)

				})

				/*infinite.on('scrollstart', (e) => {

				 ticker.sleep()

				 infinite.scroll_to(posi
				 tion, 0)

				 })

				 infinite.on('scrollend', (e) => {

				 const pos = infinite.get_computed_position()

				 position = pos.x

				 ticker.wake()
				 })*/
			}
		})
	});


}

function init_glider_cursor (glider_contain, glider_component)
{
	const glider_cursor = glider_contain.querySelector('.glider-cursor')
	const node = glider_contain.querySelector('.glider-cursor-wrap')
	const cta_buttons = glider_contain.querySelectorAll('.gt-card-cta')
	const txt_elements = glider_contain.querySelectorAll('p,h1,h2,h3,h4,h5,h6,a.gt_topic');

	glider_contain.classList.add('glider-use-cursor');

	const arrow_containers = glider_contain.querySelectorAll('.glider-arrow-container')
	arrow_containers.forEach((e) => {
		e.style.display = "none";
	});

	let cursor_inside_glider = false
	let cached_rect = null
	let cached_rect_valid = false
	let cta_hovered = false
	let clicked = false
	let mouse_up = false

	function update_bounding_rect ()
	{
		const rect = node.getBoundingClientRect()

		cached_rect = {
			top: rect.top,
			right: rect.right,
			bottom: rect.bottom,
			left: rect.left,
			width: rect.width,
			height: rect.height,
			x: rect.x,
			y: rect.y
		}

		cached_rect_valid = true
	}

	function get_bounding_rect ()
	{
		if (!cached_rect_valid) {
			update_bounding_rect()
		}

		return cached_rect
	}

	const refresh_cta_hover_status = (e, hovered) => {
		cta_hovered = hovered
		refresh_cursor(e)
	};


	const refresh_cursor = (e, do_click) => {

		const rect = get_bounding_rect()

		const mouseX = e.clientX
		const mouseY = e.clientY
		const is_dragging = e.buttons === 1 && (e.movementX || e.movementY)

//		document.body.classList.toggle("gt-dragging", is_dragging)

		cursor_inside_glider = !(mouseX < rect.left ||
		mouseX > rect.left + rect.width ||
		mouseY < rect.top || mouseY > rect.top + rect.height)

		if (cursor_inside_glider && !cta_hovered) {
			glider_cursor.classList.add('glider-cursor-visible')
			glider_contain.classList.add('glider-use-cursor')
		}
		else {
			glider_cursor.classList.remove('glider-cursor-visible')
			glider_contain.classList.remove('glider-use-cursor')
		}

		if (clicked === true) {
			glider_cursor.classList.add('glider-cursor-clicked')
		}
		else {
			glider_cursor.classList.remove('glider-cursor-clicked')
		}

		if (cursor_inside_glider) {
			const x = e.clientX - rect.left;
			const y = e.clientY - rect.top;

			glider_cursor.style.setProperty('--ui-translate-x', `${x}px`)
			glider_cursor.style.setProperty('--ui-translate-y', `${y}px`)
		}

		const middle_x = rect.left + (rect.width / 2);
		const cursor_is_left = mouseX < middle_x
		if (cursor_is_left) {
			glider_cursor.classList.remove('glider-cursor-right')
			glider_cursor.classList.add('glider-cursor-left')
		}
		else {
			glider_cursor.classList.remove('glider-cursor-left')
			glider_cursor.classList.add('glider-cursor-right')
		}

		if (cursor_inside_glider && !cta_hovered && do_click) {
			if (cursor_is_left) {
				glider_component.scrollItem('prev')
			}
			else {
				glider_component.scrollItem('next')
			}
		}
	}

	const invalidate_rect_cache = () => {
		cached_rect_valid = false
	};

	window.addEventListener("scroll", invalidate_rect_cache, {passive: true})
	window.addEventListener("resize", invalidate_rect_cache, {passive: true})

	cta_buttons.forEach((cta) => {
		cta.addEventListener("mouseover", (e) => refresh_cta_hover_status(e, true), {passive: true})
		cta.addEventListener("mouseout", (e) => refresh_cta_hover_status(e, false), {passive: true})
	});

	txt_elements.forEach((el) => {
		el.addEventListener("mouseover", (e) => refresh_cta_hover_status(e, true), {passive: true})
		el.addEventListener("mouseout", (e) => refresh_cta_hover_status(e, false), {passive: true})
	});

	document.addEventListener('click', (e) => refresh_cursor(e, true), {passive: true})

	document.addEventListener("mousedown", (e) => {
		clicked = true
		refresh_cursor(e)
	}, {passive: true})

	document.addEventListener("mouseup", (e) => {
		clicked = false
		refresh_cursor(e)
	}, {passive: true});

	document.addEventListener("mousemove", (e) => {
		refresh_cursor(e)
	}, {passive: true})

	document.addEventListener("mouseout", (e) => {
		refresh_cursor(e)
	}, {passive: true});
}

function init_anchor_sections ()
{
	let newActiveLink = null;

	window.arrive('.gt-anchor-section', (section) => {
		const container = document.querySelector('.gt-sticky-bar .ui-scroll-x'); // Ersetze '.container' mit dem entsprechenden Selektor deines Containers mit overflow-x: scroll

		const navLinks = document.querySelectorAll('.gt-sub-nav-link');
		//const sections = document.querySelectorAll('.gt-anchor-section');
		let activeLink = null;

		function setActiveLink ()
		{

			const viewportHeight = window.innerHeight || document.documentElement.clientHeight

			const rect = section.getBoundingClientRect()

			const sectionTop = rect.top
//				const sectionHeight = rect.height
			const sectionBottom = rect.bottom
			const sectionHeight = sectionBottom - sectionTop
			//const elementVisiblePercentage = (sectionHeight / viewportHeight) * 100var viewportHeight = window.innerHeight;
			const distanceThreshold = 120;

			if (sectionTop <= distanceThreshold)
			{
				const targetId = section.getAttribute('id');
				newActiveLink = document.querySelector('a[href="#' + targetId + '"]');
			}

			if (newActiveLink !== activeLink) {
				navLinks.forEach(function (link) {
					link.classList.remove('gt-sub-nav-link-active');
				});

				if (newActiveLink !== null) {
					newActiveLink.classList.add('gt-sub-nav-link-active');

					newActiveLink.scrollIntoView({block: "nearest", inline: "nearest"});
				}

				activeLink = newActiveLink;
			}
		}

		window.addEventListener('scroll', setActiveLink);
		setActiveLink();
	})
}

function init_header_sentinel ()
{
	arrive('.gt-header', function (header) {
		const sentinel = document.querySelector('.gt-sticky-header-sentinel')
		if(sentinel instanceof HTMLElement) {
			const handler = (entries) => {
				if (!entries[0].isIntersecting) {
					header.classList.add('gt-is-sticky')
				}
				else {
					header.classList.remove('gt-is-sticky')
				}
			}
			const observer = new IntersectionObserver(handler)
			observer.observe(sentinel)
		}
	})

	window.document.addEventListener('scroll', () => {
		const sections = [...document.querySelectorAll('[data-sticky="section"]')]
		const header = document.querySelector('.gt-header')

		if (header)
		{
			const header_rect = header.getBoundingClientRect()
			const body_rect = document.body.getBoundingClientRect()
			const body_top = body_rect.top;
			const header_height = header_rect.height

			/*if (body_top <= -74) {
			 requestAnimationFrame(() => {
			 header.classList.add('gt-header-stuck');
			 })
			 }
			 else {
			 requestAnimationFrame(() => {
			 header.classList.remove('gt-header-stuck');
			 })
			 }*/

			let s = false
			for (const section of sections)
			{
				//const top = section.getBoundingClientRect().top
				const bar = section.querySelector('.gt-sticky-bar')
				const top = Math.round(bar.getBoundingClientRect().top)

				if (!s && bar && top == header_height)
				{
					s = true
					requestAnimationFrame(() => {
						bar.classList.add('gt-sticky-bar-stuck')
					})
				}
				else {
					requestAnimationFrame(() => {
						bar.classList.remove('gt-sticky-bar-stuck')
					})
				}
			}
		}
	});
}

function init_glider ()
{

	function responsive_options (num)
	{
		const options = [];

		return options
	}

	arrive('.glider-contain', function (glider_contain) {

		const glider = glider_contain.querySelector('.glider')
		if (glider) {

			const prev = [...glider_contain.querySelectorAll('.glider-prev')]
			const next = [...glider_contain.querySelectorAll('.glider-next')]

			const dots = glider_contain.querySelector('.glider-dots')

			requestAnimationFrame(() => {
				const glider_component = new Glider(glider, {
					skipTrack: true,
					slidesToShow: 1.1,
					slides: '.gt-tile',
					rewind: true,
					responsive: responsive_options(1),
					arrows: {
						prev: prev,
						next: next
					},
					dots
				});


				init_glider_cursor(glider_contain, glider_component)
			})
		}
	});
}

function load_page (url, callback)
{
	const queue = request_queue();

	queue.add((request_id) => {
		const xhr = new_xml_http_request('GET', url, true)
		xhr['id'] = request_id

		xhr.onload = () => {
			queue.on_complete(xhr, () => {
				let resp_location = xhr.getResponseHeader('X-Location')
				const page = document.getElementById('page');
				//const id = page.dataset.view;

				const result = merge_xhr_result(xhr)
				if (callback) {
					const merged_id_elements = result.ids
					if (merged_id_elements.indexOf('page') < 0) {
						// keep window.location state, only widgets are merged (e.g. modal dialog)
						resp_location = undefined
					}

					callback(resp_location)
				}
			})
		}

		xhr.send();
	});
}

async function install_stripe_js ()
{
	let key = document.documentElement.dataset.stripeKey
	if (key) {

		const sandbox = 'pk_test_8uZXK82UPwSQA6Yjcuxb2VhV00WjNNaUFx'
		//let key = 'pk_live_hOE6nkt3AXEyyfIIF5QiP1ul00keGVFYma';
		if (window.location.href.includes('.local') ||
		window.location.href.includes('-test') ||
		window.location.href.includes('ngrok.io'))
		{
			key = sandbox;
		}

		const stripe = await loadStripe(key)
		let elements, elements_sepa, elements_sofort, elements_customer_balance,
		cur_submit_handler, cur_form, cur_form_context

		function show_msg (text)
		{
			const msg_container = document.querySelector("#payment-message")
			if (msg_container) {
				msg_container.classList.remove("hidden");
				msg_container.textContent = text;

				setTimeout(function () {
					msg_container.classList.add("hidden");
					text.textContent = "";
				}, 4000)
			}
		}

		async function handle_customer_balance_submit (e)
		{
			return handle_submit(e, elements_customer_balance)
		}

		async function handle_sofort_submit (e)
		{
			return handle_submit(e, elements_sofort)
		}

		async function handle_sepa_submit (e)
		{
			return handle_submit(e, elements_sepa)
		}

		async function handle_card_submit (e)
		{
			return handle_submit(e, elements)
		}

		async function handle_submit (e, elements)
		{
			e.preventDefault()
			e.stopPropagation()

			const spinner = e.target.querySelector('.spinner')
			if (spinner) {
				spinner.removeAttribute('hidden')
			}

			const url = new URL("./success", window.location.href)
			const {error} = await stripe.confirmPayment({
				elements,
				confirmParams: {
					return_url: url.toString(),
					payment_method_data: {
						billing_details: {
							address: {
								city: null,
								country: null,
								line1: null,
								line2: null,
								postal_code: null,
								state: null,
							},
							email: null,
							name: null,
							phone: null
						}
					}
				}
			})

			if (error.type === "card_error" || error.type === "validation_error") {
				show_msg(error.message);
				if (spinner) {
					spinner.toggleAttribute('hidden')
				}
			}
			else {
				show_msg("An unexpected error occurred.")
				if (spinner) {
					spinner.toggleAttribute('hidden')
				}
			}
		}

		async function initialize ()
		{
			const card_form = document.getElementById('card-form')
			const sepa_form = document.getElementById('sepa-form')
			const sofort_form = document.getElementById('sofort-form')
			const customer_balance_form = document.getElementById('customer-balance-form')

			const options = {
				terms: {
					sepaDebit: 'never'
				},
				fields: {
					billingDetails: {
						'address': 'never'
					}
				}
			}

			if (cur_submit_handler && cur_form instanceof HTMLFormElement) {
				cur_form.removeEventListener('submit', cur_submit_handler)
				cur_submit_handler = null
				cur_form = null
				cur_form_context = null
			}

			const on_mount_ready = function (event) {

				const parent = parent_matches(cur_form_context, '.reveal-if-active')

				const loader = parent.querySelector(".dropin-loading")
				const dropin = parent.querySelector(".dropin-container")

				loader.toggleAttribute('hidden')
				dropin.toggleAttribute('hidden')
			}

      const darkModeAppearanceVariables = {
        colorPrimary: "#e6b356",              // gold für highlights
        colorText: "#c2c6d2",
        colorBackground: "#14172A",           // canvas
        buttonSecondaryColorBackground: "#2B3039",
        buttonSecondaryColorText: "#c2c6d2",
        colorSecondaryText: "#8C99AD",
        actionSecondaryColorText: "#c2c6d2",
        actionSecondaryTextDecorationColor: "#c2c6d2",
        colorBorder: "#2B3039",
        colorDanger: "rgb(185, 60, 60)",

        badgeNeutralColorBackground: "#1B1E25",
        badgeNeutralColorBorder: "#2B3039",
        badgeNeutralColorText: "#8C99AD",

        badgeSuccessColorBackground: "#152207",
        badgeSuccessColorBorder: "#20360C",
        badgeSuccessColorText: "#3EAE20",

        badgeWarningColorBackground: "#400A00",
        badgeWarningColorBorder: "#5F1400",
        badgeWarningColorText: "#F27400",

        badgeDangerColorBackground: "#420320",
        badgeDangerColorBorder: "#61092D",
        badgeDangerColorText: "#F46B7D",

        offsetBackgroundColor: "#1B1E25",
        formBackgroundColor: "#14172A",        // canvas shining through
        overlayBackdropColor: "rgba(0,0,0,0.5)"
      };

      const appearance = {
        variables:darkModeAppearanceVariables
      }

			if (card_form)
			{
				cur_form = parent_by_tag_name(cur_form_context = card_form, 'form')
				cur_form.addEventListener('submit', (cur_submit_handler = handle_card_submit))
				const client_secret = card_form.dataset.clientSecret
				elements = stripe.elements({
					clientSecret: client_secret,
					locale: 'de',
          appearance
				})

				const payment_element = elements.create("payment", options)
				payment_element.on('ready', on_mount_ready)
				payment_element.mount("#dropin-container")
			}

			if (sofort_form)
			{
				cur_form = parent_by_tag_name(cur_form_context = sofort_form, 'form')
				cur_form.addEventListener('submit', (cur_submit_handler = handle_sofort_submit))
				const client_secret = sofort_form.dataset.clientSecret
				elements_sofort = stripe.elements({
					clientSecret: client_secret,
					locale: 'de',
          appearance
				})

				const payment_element_sofort = elements_sofort.create("payment", options)
				payment_element_sofort.on('ready', on_mount_ready)
				payment_element_sofort.mount("#sofort-dropin-container")
			}

			if (customer_balance_form)
			{
				cur_form = parent_by_tag_name(cur_form_context = customer_balance_form, 'form')
				cur_form.addEventListener('submit', (cur_submit_handler = handle_customer_balance_submit))
				const client_secret = customer_balance_form.dataset.clientSecret
				elements_customer_balance = stripe.elements({
					clientSecret: client_secret,
					locale: 'de',
          appearance
				})

				const payment_element_customer_balance = elements_customer_balance.create("payment", options)
				payment_element_customer_balance.on('ready', on_mount_ready)
				payment_element_customer_balance.mount("#customer-balance-dropin-container")
			}

			if (sepa_form) {

				cur_form = parent_by_tag_name(cur_form_context = sepa_form, 'form')
				cur_form.addEventListener('submit', (cur_submit_handler = handle_sepa_submit))
				const sepa_secret = sepa_form.dataset.clientSecret
				elements_sepa = stripe.elements({
					clientSecret: sepa_secret,
					locale: 'de',
          appearance
				})

				const payment_element_sepa = elements_sepa.create("payment", options)
				payment_element_sepa.on('ready', on_mount_ready)
				payment_element_sepa.mount("#sepa-dropin-container")
			}
		}

		window.arrive('.dropin-container', () => initialize())

		await initialize()
	}
}

function install_sortable ()
{
	window.arrive('[data-sortable]', sortable =>
	{
		const group = sortable.dataset.sortable
		const hide_them = sortable.querySelectorAll('[data-sortable-hidden]');
		const drag_handles = sortable.querySelectorAll('.drag_handle')

		const on_drag_start = function ()
		{
			for (let i = 0; i < hide_them.length; i++) {
				hide_them[i].setAttribute('hidden', 'hidden')
			}
		}

		for (let i = 0; i < drag_handles.length; i++) {
			const drag_handle = drag_handles[i];
			drag_handle.addEventListener('mousedown', on_drag_start, true);
			drag_handle.addEventListener('touchstart', on_drag_start, true);
			drag_handle.addEventListener('pointerdown', on_drag_start, true);
		}

		const on_change = (evt) => {
			const item = evt.item
			for (let i = 0; i < hide_them.length; i++) {
				hide_them[i].removeAttribute('hidden')
			}

			const form = nearest_form(item)
			if (form) {
				associate_form_elements(item, form)

				/*	for(let i=0; i < form.elements.length; i++)
				 {
				 alert(form.elements[i].name + "=" + form.elements[i].value)
				 }*/

				form.submit()
			}
		}

		new Sortable(sortable, {
			animation: 150,
			'group': group,
			swapThreshold: 0.10,
			fallbackOnBody: true,
			handle: '.drag_handle',
			onAdd: on_change,
			onUpdate: on_change
		});
	});
}

function associate_form_elements (el, form)
{
	if (form.id) {
		const form_id = form.id
		const form_container = parent_matches(form, '[data-form]') || form
		const elements = []
		descendants(form_container, (e) => {
			if (matches_selector(e, 'input, select, textarea')) {
				elements.push(e)
			}
			else {
				return !(matches_selector(e, 'form') && strcmp(form_id, e.id) === 0)
			}
		})

		alert(elements.length);

		for (let i = 0; i < elements.length; i++)
		{
			elements[i].setAttribute('form', form_id)
		}
	}
}

function nearest_form (el)
{
	let form = parent_by_tag_name(el, 'form')

	if (!(form instanceof HTMLFormElement)) {
		form = parent_matches(el, '[data-form]')
		if (form) {
			form = document.getElementById(form.dataset.form)
		}
	}

	if (form instanceof HTMLFormElement) {
		return form
	}
}

function throttle (fn, threshold, scope)
{
	threshold || (threshold = 25);
	var last,
	deferTimer;
	return function () {
		var context = scope || this;

		var now = +new Date,
		args = arguments;
		if (last && now < last + threshold) {
			// hold on to it
			clearTimeout(deferTimer);
			deferTimer = setTimeout(function () {
				last = now;
				fn.apply(context, args);
			}, threshold);
		}
		else {
			last = now;
			fn.apply(context, args);
		}
	};
}

function install_autosubmit ()
{
	const scope = new Scope
	const callback = throttle((target) => {
		target.form.submit()
	}, 10)

	const options = {passive: true, capture: true}

	const change_listener = (target) => {
		if (target && target.form && (target.dataset.autosubmit !== undefined))
		{
			callback(target)
			return false
		}

		return true
	}


//	window.addEventListener('input', change_listener, options)
//	window.addEventListener('change', change_listener, options)

	window.addEventListener('keyup', () => scope.digest(), options)
	window.addEventListener('mouseup', () => scope.digest(), options)

	arrive('textarea', (elem) => {
		scope.watch(() => elem.value, change_listener)
	})

	arrive('input', (elem) => {
		scope.watch(() => elem.value, () => change_listener(elem))
	})

	return scope
}

function install_textarea_autogrow ()
{
	arrive('.o-auto-grow textarea', (field) => {

		field.addEventListener('input', () => {
			let val = field.value
			if (field.dataset.behavior && field.dataset.behavior.includes('nowrap')) {
				val = val.replace(/\n/g, "");
				field.value = val
			}

			field.parentNode.setAttribute('data-text', val)
		}, {passive: true});

		field.parentNode.setAttribute('data-text', field.value);
	})
}

function install_editor (scope)
{
	window.RedactorX = RedactorX
	arrive('#editor', (e) => {

		RedactorX(e, {

			paddingNormal: false,

			editor: {
				minHeight: '320px',
				drop: false,
			},

			subscribe: {
				'editor.change': function (e) {
					scope.digest()
				}
			},

			toolbar: {
				stickyTopOffset: 70
			},

			image: {
				url: false,
				select: './images.json',
			}
		})
	})

}

function install_intercept ()
{
	let cached_location
	window.addEventListener('popstate', (e) => {

		log('popstate');

		if (!cached_location || 0 !== strcmp(cached_location, window.location)) {
			cached_location = window.location;
			log("popstate refresh url");
			window.location.replace(window.location);
		}
	});

	(function intercept_links () {

		function on_click_edit_link (e)
		{
			e.preventDefault()

			let elem = e.target

			if (!is_html_anchor(elem)) {
				elem = parent_by_tag_name(elem, 'a')
			}

			if (is_html_anchor(elem)) {
				start_progress()

				let href = elem.getAttribute('href')
				if (!is_string(href)) {
					return;
				}

				const url = new URL(href, window.location.href);

				load_page(url, (resp_url) => {
					resp_url = resp_url ? resp_url.toString() : undefined
					on_merge_result(url, resp_url)
				})
			}
		}

		const handler = elem => {
			const href = elem.getAttribute('href')
			if (is_string(href) && !href.startsWith('#') && !href.startsWith("http")
			&& !href.startsWith("mailto:"))
			{
				elem.addEventListener('click', on_click_edit_link);
			}
		}

		//	arrive('a:not(.nav-link):not(.nojs)', handler)

		arrive(':not(.nojs)', handler)
	})()

	let submit_origin;
	intercept_forms((e, form) => {

		start_progress()

		const target = form || e.target;
		let action_url = window.location.href;
		if (target instanceof HTMLFormElement) {
			if (target.hasAttribute('action')) {
				action_url = target.getAttribute("action");
			}
		}

		log('form action url ' + action_url);
		log('last clicked element ' + last_clicked_element);

		let method = 'POST'
		if(form instanceof HTMLFormElement) {
			method = form.method
		}

		const data = new FormData(target)

		if (last_clicked_element) {
			const is_form_descendant = is_child_of(last_clicked_element, target)
			const form_id = target.getAttribute('id')
			const btn_form_attr = last_clicked_element.getAttribute('form')
			const belongs_to_form = strcmp(form_id, btn_form_attr) >= 0

			if (is_form_descendant || belongs_to_form) {
				action_url = last_clicked_element.getAttribute('formaction') || action_url
				const name = last_clicked_element.name;
				const val = last_clicked_element.value;
				if (!empty(name)) {
					data.append(name, val)
				}

				// TODO thomas: workaround to detect any clicked
				// also if button has any other name as 'submit' (@see CRUD_Controller_base.php)
				//data.append("submit[submit]", 'submit');
			}
		}

		if (e && e.preventDefault) {
			e.preventDefault();
		}

		if (submit_origin && submit_origin.value) {
			if (submit_origin.value.length < 3) {
				data.append(submit_origin.name, '');
			}
		}

		submit_form_data(data, action_url, {'method': method}, (xhr) => {

			last_clicked_element = null

			//const fragment = xhr.getResponseHeader('X-Fragment')
			const resp_url = xhr.getResponseHeader('X-Location')

			submit_origin = undefined


			//set_target(fragment)

			const result = merge_xhr_result(xhr)
			if (result && result.new_document) {
				const old_map_script = document.body.querySelector('script[data-name=maps]');
				const new_map_script = result.new_document.body.querySelector('script[data-name=maps]');
				if (old_map_script && new_map_script) {
					const parent = old_map_script.parentElement;
					parent.removeChild(old_map_script);
					parent.appendChild(new_map_script);
				}

				on_merge_result(action_url, resp_url)
			}

			end_progress()
		});
	});
}


/**
 * Easy selector helper function
 */
const select = (el, all = false) => {
	el = el.trim()
	if (all) {
		return [...document.querySelectorAll(el)]
	}
	else {
		return document.querySelector(el)
	}
}

const nodes = document.querySelectorAll('[data-merge-safelist]');
for (let i = 0; i < nodes.length; ++i) {
	const node = nodes[i];

	emplace_token_list(node, 'data-merge-safelist')
}

init_anchor_sections()
init_header_sentinel()
init_glider()
init_infinite()
install_intercept()
install_editor(install_autosubmit())
install_textarea_autogrow();

function insert_after (new_node, node)
{
	node.parentNode.insertBefore(new_node, node.nextSibling);
}


//install_modal('ui')

install_modal('ui', function (activated, wrapper) {

	const id = wrapper.getAttribute('id')
	const is_mobile_nav = strcmp(id, 'mobile-nav') === 0

	if (activated && is_mobile_nav) {
		const header = select('.gt-header', false)

		const body_rect = document.body.getBoundingClientRect()

		let top = 'auto'
		if (body_rect.top < 0) {
			top = Math.abs(body_rect.top) + 'px'
		}

		insert_after(header.cloneNode(true), header)
		const s = header.style
		s.position = 'absolute'
		s.top = top
		s.left = '0'
		s.right = '0'
		s.zIndex = 'auto'
		header.nextSibling.style.visibility = 'hidden'
	}
	else if (is_mobile_nav) {
		const header = select('.gt-header', false)
		header.removeAttribute('style')
		header.parentNode.removeChild(header.nextSibling)
	}

});


install_sortable()

window['refresh_page'] = function ()
{
	const url = window.location.href
	load_page(url, (resp_url) => {
		resp_url = resp_url ? resp_url.toString() : undefined
		on_merge_result(url, resp_url)
	})
}

install_stripe_js();

window['scan_qr'] = scan_qr;
